import script from "./TestResultView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TestResultView.vue?vue&type=script&setup=true&lang=ts"

import "./TestResultView.vue?vue&type=style&index=0&id=578fbc56&lang=css"

const __exports__ = script;

export default __exports__